import React, {useContext, useEffect, useState} from "react";
import ProgressLoading from "../loading/ProgressLoading";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import Button from "../Button";
import BottomButtonWrapper from "../BottomButtonWrapper";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import Final from "./Final";

const BusinessLicenseInquiry = () => {
    const [isLoading, setLoading] = useState(true);
    const serviceContext = useContext(AuthenticationServiceContext);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [loadingText, setLoadingText] = useState('در حال دریافت اطلاعات پروانه شما');
    const [isReported,setIsReported]=useState(false);
    const [reportMessage,setReportMessage]=useState('')
    const handleBusinessLicenseInquiry = () => {

        setLoading(true);
        handleGenerateUuid("BusinessLicenseInquiry", serviceContext.token).then(uuid => {
            Api.post(REQUEST_URLS.AUTHENTICATION.BUSINESS_LICENSE_INQUIRY, {
                uuid: uuid,
                pid: serviceContext.pid,
            }, {
                headers: {
                    "Authorization": `Bearer ${serviceContext.token}`
                }
            }).then(response => {
                const {hasError, data, message, status} = response;
                if (hasError) {
                    setLoading(false)
                    serviceContext.handleError({
                        status,
                        message,
                        data,
                        callback: () => {

                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {

                                    if (data.can_skip) {
                                        serviceContext.handleSkip(serviceContext.pid)
                                    } else {

                                    }
                                    Reoverlay.hideModal();
                                },
                                confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                                showConfirmButton: data.can_skip ? data.can_skip : false,
                                showCancelButton: true,
                                cancelButtonText: data.can_reset ? status === 110 ? 'تلاش مجدد' : 'ویرایش اطلاعات' : 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                confirmButtonTheme: "green",
                                onCancel: () => {
                                    if (data?.can_reset) {
                                        if (status === 110) {
                                            handleBusinessLicenseInquiry(serviceContext.pid)
                                        } else {
                                            serviceContext.handleReset(serviceContext.pid);
                                        }

                                    } else {
                                        handleBusinessLicenseInquiry(serviceContext.pid)
                                    }
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                } else {
                    if (data) {
                        setCompanyList(data.data);
                        setSelectedCompany(data.data.length === 1 ? {...data.data[0], bIndex: 0} : null)
                        setLoading(false)
                    }

                }
            }).catch(e => {

            })
        });
    }
    const handleConfirm = () => {
        setLoadingText('لطفا منتظر بمانید');
        setLoading(true);
        const data = {
            pid: serviceContext.pid,
            bi_index: selectedCompany.bIndex,
        };


        Api.put(REQUEST_URLS.AUTHENTICATION.CONFIRM_BUSINESS, data, {
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then(response => {
            const {hasError, message, status, data} = response;
            if (hasError) {
                setLoading(false)
                serviceContext.handleError({
                    status, data, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            onConfirm: () => {

                                if (data.can_skip) {
                                    serviceContext.handleSkip(serviceContext.pid)
                                } else {

                                }
                                Reoverlay.hideModal();
                            },
                            confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                            showConfirmButton: data.can_skip ? data.can_skip : false,
                            showCancelButton: true,
                            cancelButtonText: data.can_reset ? status === 110 ? 'تلاش مجدد' : 'ویرایش اطلاعات' : 'تلاش مجدد',
                            cancelButtonTheme: 'red',

                            onCancel: () => {
                                if (data.can_reset) {
                                    if (status === 110) {

                                    } else {
                                        serviceContext.handleReset();
                                    }

                                }
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            } else {
                if(data.warning){
                    setIsReported(true);
                    setReportMessage(data.warning);
                    setLoading(false)
                }else {
                    serviceContext.handleGetProcess(serviceContext.pid)
                }

            }
        }).catch(e => {

        })
    }
    useEffect(() => {
        handleBusinessLicenseInquiry()
    }, [])
    if (isLoading) {
        return <ProgressLoading showProgress={false} type="NIDCardReader" duration={30} text={loadingText}
                                theme="green"/>
    }
    if(isReported){
        return  <Final isDisableTitle={false} message={reportMessage}/>
    }
    return <div className="mt-5 w-11/12 lg:w-4/12 flex flex-col mx-auto  items-center justify-center ">
        {companyList.length > 0 && <>
            <h1>{companyList.length === 1 ? 'اطلاعات پروانه شما به صورت زیر است.' : 'لطفا پروانه مرتبط به این آگهی را انتخاب کنید.'}</h1>
            {companyList.map((company, index) => {
                return <div key={'company' + index} onClick={() => setSelectedCompany({...company, bIndex: index})}
                            className={`flex justify-between  ${selectedCompany && (selectedCompany.TradeId === company.TradeId) ? " border-2 bg-white border-green-500" : " border-2 bg-white border-white"}  items-center  w-full mt-3    border rounded-lg  `}>
                    <div className="flex flex-col w-full">
                        <div className="w-full  p-3 border-b border-l flex  grid grid-cols-2   items-center ">
                            <span className=" text-sm whitespace-nowrap">نام شرکت</span>

                            <strong className="text-sm ">{company.CompanyName}</strong>
                        </div>
                        <div className="w-full flex border-b border-l  p-3   grid grid-cols-2   items-center ">
                            <span className=" text-sm  whitespace-nowrap">نام </span>

                            <strong className="text-sm whitespace-nowrap">{company.Name}</strong>
                        </div>
                        <div className="w-full flex grid border-l grid-cols-2   p-3  items-center ">
                            <span className=" text-sm whitespace-nowrap">رسته </span>
                            <strong className="text-sm  ">{company.Field}</strong>
                        </div>
                        {/*  <div className="w-full flex grid border-l border-t grid-cols-2   p-3  items-center ">
                            <span className=" text-sm whitespace-nowrap">وضعیت</span>
                            <strong className="text-sm  whitespace-nowrap">{company.Status.FaType}</strong>
                        </div>*/}
                    </div>
                    <div className="p-3 ">
                        {selectedCompany && (selectedCompany.TradeId === company.TradeId) ?
                            <div className="w-5 h-5 rounded-full border p-0.5  ">
                                <div className="w-full h-full rounded-lg bg-green-500"></div>
                            </div> : <div className="w-5 h-5 bg-gray-100 rounded-full border "></div>}
                    </div>


                </div>
            })}
            <BottomButtonWrapper grid={1}>
                <Button onClick={handleConfirm} disabled={!selectedCompany} theme="green" rounded="rounded-lg"
                        className="text-sm">تایید</Button>
            </BottomButtonWrapper>
        </>}
    </div>
}
export default BusinessLicenseInquiry;